import React from 'react';

import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';

import { Typography } from '../Typography';

export interface SectionItemProps {
  children?: React.ReactNode;
  className?: string;
  dense?: boolean;
  label: string;
  rightHeader?: React.ReactNode;
}

const useStyles = makeStyles((theme: Theme) => ({
  sectionItem: {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  headerWrapper: {
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  leftHeader: {
    fontStyle: 'normal',
  },
}));

export function SectionItem(props: SectionItemProps): JSX.Element {
  const { children, className = '', dense, label, rightHeader } = props;
  const classes = useStyles();

  const sectionListStyles = clsx(
    !dense && classes.sectionItem,
    className || '',
  );

  return (
    <div aria-label={label} className={sectionListStyles} role="region">
      <div className={classes.headerWrapper}>
        <Typography variant="h3">{label}</Typography>

        {rightHeader || null}
      </div>

      {children || null}
    </div>
  );
}
